<template>
  <transition name="modal">
    <div
      class="PopUp"
      v-if="show && (type == 'info' || type == 'default')"
      @touchmove="notAllowTouchMove($event)"
    >
      <div class="message" :class="msgBody.cssClass" :style="msgBody.style">
        <div class="title" :cssClass="title.cssClass" :style="title.style">
          {{ title.content }}
          <div
            class="closeBtn"
            role="close-button"
            :class="closeBtn.cssClass"
            :style="closeBtn.style"
            @click="dismiss($event)"
          ></div>
        </div>
        <div
          class="msg"
          v-html="message.content"
          :style="message.style"
          :class="message.cssClass"
        ></div>
        <div
          class="msgFooter"
          :class="msgFooter.cssClass"
          :style="msgFooter.style"
        >
          <div
            class="footerBtn"
            v-for="item in buttons"
            :class="item.cssClass"
            :style="item.style"
            @click="item.action"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="mask" @click="dismiss($event)"></div>
    </div>
    <div
      class="PopUp"
      v-if="show && type == 'search_person'"
      @touchmove="notAllowTouchMove($event)"
    >
      <div class="message" :class="msgBody.cssClass" :style="msgBody.style">
        <div class="title" :cssClass="title.cssClass" :style="title.style">
          {{ title.content }}
          <div
            class="closeBtn"
            role="close-button"
            :class="closeBtn.cssClass"
            :style="closeBtn.style"
            @click="dismiss($event)"
          ></div>
        </div>
        <v-form ref="form" v-model="valid" :lazy-validation="true">
          <v-container class="msg">
            <v-layout row wrap class="section-container">
              {{ message.content }}
              <v-flex xs12 md12 class="item">
                <v-text-field
                  v-model="name"
                  :label="'params.name' | i18n"
                  outline
                  :rules="[
                    v =>
                      v.length == 0 ||
                      v.length >= 3 ||
                      getTranslate('errors.write_3_characters')
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12 class="item">
                <v-text-field
                  v-model="dni"
                  :label="'params.dni' | i18n"
                  outline
                  :rules="[
                    v =>
                      v.length == 0 ||
                      v.length >= 3 ||
                      getTranslate('errors.write_3_characters')
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12 class="item">
                <v-text-field
                  v-model="email"
                  :label="'params.email' | i18n"
                  outline
                  :rules="[
                    v =>
                      v.length == 0 ||
                      v.length >= 3 ||
                      getTranslate('errors.write_3_characters')
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12 class="item" v-show="search"
                >{{ getTranslate("results") }}: {{ persons | length }}</v-flex
              >
              <v-flex
                xs12
                md12
                @click="action('go_person_card', person.id)"
                class="item person"
                v-for="(person, k) in persons.slice(0, 5)"
                v-show="search"
                :key="k"
              >
                <div class="box">
                  <div class="name">{{ person.name | checkParam }}</div>
                  <div class="email">{{ person.email | checkParam }}</div>
                </div>
                <div class="box">
                  <div class="dni">{{ person.dni | checkParam }}</div>
                  <div class="birthday">{{ person.birthday | formatDate }}</div>
                </div>
                <div class="box">
                  <div class="role" :class="['r' + person.role.id]">
                    {{ person.role.name }}
                  </div>
                  <div class="entity">{{ person.role.entity }}</div>
                </div>
              </v-flex>
              <v-flex
                xs12
                md12
                class="item"
                v-show="search && persons.length == 0"
                >{{ getTranslate("no_results") }}</v-flex
              >
              <v-flex
                xs12
                md12
                class="item"
                v-show="search && persons.length > 5"
                >{{ getTranslate("much_results") }}</v-flex
              >
            </v-layout>
          </v-container>
        </v-form>
        <div
          class="msgFooter"
          :class="msgFooter.cssClass"
          :style="msgFooter.style"
        >
          <div
            class="footerBtn"
            v-for="item in buttons"
            :class="item.cssClass"
            :style="item.style"
            @click="action(item.action)"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
      <div class="mask" @click="dismiss($event)"></div>
    </div>
    <div
      class="PopUp"
      v-if="show && type == 'myteams'"
      @touchmove="notAllowTouchMove($event)"
    >
      <div class="message" :class="msgBody.cssClass" :style="msgBody.style">
        <div class="title" :cssClass="title.cssClass" :style="title.style">
          {{ title.content }}
          <div
            class="closeBtn"
            role="close-button"
            :class="closeBtn.cssClass"
            :style="closeBtn.style"
            @click="dismiss($event)"
          ></div>
        </div>
        <div class="msg" :style="message.style" :class="message.cssClass">
          <div class="myteam">
            <a
              :href="
                api_url +
                  'team/' +
                  team_id +
                  '/event/' +
                  event_id +
                  '/myteams?authorization=' +
                  user_token +
                  '&lang=ca'
              "
              target="_blank"
              >Obrir en català</a
            >
          </div>
          <div class="myteam">
            <a
              :href="
                api_url +
                  'team/' +
                  team_id +
                  '/event/' +
                  event_id +
                  '/myteams?authorization=' +
                  user_token +
                  '&lang=es'
              "
              target="_blank"
              >Obrir en castellà</a
            >
          </div>
          <div class="myteam">
            <a
              :href="
                api_url +
                  'team/' +
                  team_id +
                  '/event/' +
                  event_id +
                  '/myteams?authorization=' +
                  user_token +
                  '&lang=en'
              "
              target="_blank"
              >Obrir en angles</a
            >
          </div>
        </div>
        <div
          class="msgFooter"
          :class="msgFooter.cssClass"
          :style="msgFooter.style"
        >
          <div
            class="footerBtn"
            v-for="item in buttons"
            :class="item.cssClass"
            :style="item.style"
            @click="item.action"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="mask" @click="dismiss($event)"></div>
    </div>
    <div
      class="PopUp"
      v-if="show && type == 'reject_document'"
      @touchmove="notAllowTouchMove($event)"
    >
      <div class="message" :class="msgBody.cssClass" :style="msgBody.style">
        <div class="title" :cssClass="title.cssClass" :style="title.style">
          {{ title.content }}
        </div>
        <div
          class="msg"
          v-html="message.content"
          :style="message.style"
          :class="message.cssClass"
        ></div>
        <div class="msg">
          <v-select :items="reject_document" v-model="reject_document_id">
          </v-select>
        </div>
        <div
          class="msgFooter"
          :class="msgFooter.cssClass"
          :style="msgFooter.style"
        >
          <div
            class="footerBtn"
            v-for="item in buttons"
            :class="item.cssClass"
            :style="item.style"
            @click="action(item.action)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="mask" @click="dismiss($event)"></div>
    </div>
  </transition>
</template>

<script>
import store from "@/store";
import router from "@/router";
import i18n from "@/i18n";

export default {
  data() {
    return {
      show: false,
      closable: true,
      type: "default",
      title: {
        content: "",
        cssClass: "",
        style: {}
      },
      message: {
        content: "",
        cssClass: "",
        style: {}
      },
      buttons: [],
      closeBtn: {
        cssClass: "",
        style: {}
      },
      msgBody: {
        cssClass: "",
        style: {}
      },
      msgFooter: {
        cssClass: "",
        style: {}
      },
      name: "",
      dni: "",
      email: "",
      fnSearchCallBack: function() {},
      fnCreateCallBack: function() {},
      fnCloseCallBack: function() {},
      fnGoPersonCard: function() {},
      persons: [],
      search: false,
      valid: false,
      team_id: null,
      event_id: null,
      api_url: "",
      user_token: "",
      reject_document: [],
      reject_document_id: 1
    };
  },
  methods: {
    dismiss(event) {
      if (
        !this.closable &&
        event.target.getAttribute("role") != "close-button"
      ) {
        return;
      }
      this.show = false;
      document.body.style.overflow = "auto";
    },
    notAllowTouchMove(event) {
      event.preventDefault();
    },
    action(action, params) {
      switch (action) {
        case "search":
          this.fnSearchCallBack(this, store);
          break;
        case "create":
          this.fnCreateCallBack(this, store, router);
          break;
        case "close":
          this.fnCloseCallBack(this);
          break;
        case "go_person_card":
          this.fnGoPersonCard(this, router, params);
          break;
      }
    },

    getTranslate(label) {
      return i18n.t(label);
    }
  },

  filters: {
    length(param) {
      if (typeof param === "object") return Object.keys(param).length;
      else return param.length;
    },

    formatDate(date) {
      return moment(date).isValid()
        ? moment(date).format("DD-MM-YYYY")
        : i18n.t("date.invalid");
    },

    checkParam(param) {
      return param == null ||
        param == "null" ||
        (typeof param == "string" && param.trim() == "")
        ? "N/A"
        : param;
    }
  }
};
</script>

<style lang="scss">
.PopUp {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: opacity 0.3s ease;
  -moz-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
  z-index: 9999;
  -webkit-user-select: none;

  .title {
    position: relative;
    padding: 15px;
    padding-bottom: 0;
    background: #fff;
  }
  .closeBtn {
    position: absolute;
    top: 20px;
    right: 15px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    text-align: center;
    font-size: 32px;
    z-index: 26;
    cursor: pointer;
    &:after {
      content: "\2A2F";
    }
  }
  .message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    border-radius: 10px;
    background: #fff;
    z-index: 25;
    overflow: hidden;
    display: grid;
  }
  .msg {
    position: relative;
    padding: 30px 20px;
    overflow: hidden;
    text-align: center;

    .item.flex {
      padding: 0 20px;

      .v-input:not(.v-input--radio-group) .v-input__slot {
        border: none;
        border-bottom: 2px solid rgba(0, 0, 0, 0.14);
        border-radius: 0;
        padding-left: 0;

        &:focus,
        &:hover {
          border: none;
          border-bottom: 2px solid rgba(0, 0, 0, 0.14);
        }
      }

      label {
        text-transform: capitalize;
      }
      .v-input__prepend-inner {
        margin-top: 25px;
      }

      &.person {
        display: inline;
        line-height: 30px;
        position: relative;
        cursor: pointer;
        padding: 5px 30px;

        &:not(:first-child) {
          border-top: 1px solid #ccc;
        }

        .box {
          float: left;
          width: 33%;
          display: block;
          text-align: center;

          div {
            font-size: 14px;
          }

          .name,
          .dni,
          .entity {
            // font-size: 14px;
            font-weight: bold;
          }
          .email,
          .birthday {
            // font-size: 14px;
          }

          .role {
            border-radius: 15px;
            padding: 3px 15px;
            font-weight: lighter;
            /* margin: 0 auto; */
            /* text-align: center; */
            width: fit-content;

            &.r1 {
              background-color: $bg-role-1;
              color: $co-role-1;
            }
            &.r2 {
              background-color: $bg-role-2;
              color: $co-role-2;
            }
            &.r5 {
              background-color: $bg-role-5;
              color: $co-role-5;
            }
            &.r6 {
              background-color: $bg-role-6;
              color: $co-role-6;
            }
            &.r107 {
              background-color: $bg-role-107;
              color: $co-role-107;
            }
            &.r108 {
              background-color: $bg-role-108;
              color: $co-role-108;
            }
            &.r109 {
              background-color: $bg-role-109;
              color: $co-role-109;
            }
            &.r110 {
              background-color: $bg-role-110;
              color: $co-role-110;
            }
            &.r111 {
              background-color: $bg-role-111;
              color: $co-role-111;
            }

            & .value {
              font-size: 12px;
              text-transform: uppercase;
              color: #fff;
            }
          }
        }
        // .name {
        //     width: 30%;
        //     float: left;
        // }
        // .dni, .email, .birthday {
        //     width: 20%;
        //     float: left;
        // }
      }
    }
  }
  .msgFooter {
    position: relative;
    box-sizing: border-box;
    padding: 2%;
    border-top: 1px solid #e8e8e8;
    background: #fff;
    text-align: right;
    overflow: hidden;
    height: 50px;
  }
  .footerBtn {
    display: block;
    position: relative;
    margin-right: 5px;
    margin-bottom: 0;
    padding: 0 15px;
    line-height: 1.15;
    height: 28px;
    line-height: 28px;
    border-radius: 4px;
    border: 1px solid transparent;
    border-color: #d9d9d9;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.65);
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    float: left;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

    &.search span {
      background: url(/img/magnify.svg);
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: center left;
      padding-left: 30px;
      color: inherit;
      display: inline-block;
    }
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.myteam {
  width: 100%;
  margin: 0 45%;
  font-size: 2em;
  cursor: pointer;

  a {
    font-weight: bold !important;
  }
}
.v-select-list,
.v-menu__content {
  z-index: 99999 !important;
}
</style>
